module.exports = __webpack_public_path__ + "img/CIV.31d73f49.svg";